import { PresetConfig } from '../../auth/services/PresetService';
import { AuthenticationError } from '../errors/errors';
import { CacheService } from './CacheService';
import { RuntimeCacheService } from './RuntimeCacheService';

export class AppConfigContext {
  protected static runtimeCacheService = RuntimeCacheService.getInstance();
  protected static cacheService = CacheService.getInstance();
  protected static presets: PresetConfig | null = null;

  static getToken(): string | null {
    return AppConfigContext.cacheService.getItem('token', null);
  }

  static setToken(token: string, timeoutSeconds: number) {
    AppConfigContext.cacheService.setItem('token', token, timeoutSeconds);
  }

  static clearToken() {
    AppConfigContext.cacheService.clearItem('token');
    AppConfigContext.runtimeCacheService.purgeCache();
  }

  static getPresets(): PresetConfig {
    if (AppConfigContext.presets === null) {
      throw new AuthenticationError();
    }
    return AppConfigContext.presets;
  }

  static setPresets(presets: PresetConfig) {
    AppConfigContext.presets = presets;
  }
}
